module.exports = __webpack_public_path__ + "img/image4.567ef795.jpg";